import { registerCreateServiceResponseCallback } from 'owa-service/lib/fetchWithRetry';
import {
    logServiceRequestDiagnostics,
    registerServiceRequestDiagnostics,
} from './actions/serviceRequestDiagnostics';
import { RequestOptions, InternalRequestOptions } from 'owa-service/lib/RequestOptions';

export default function initializeServiceRequestDiagnostics() {
    registerServiceRequestDiagnostics();
    registerCreateServiceResponseCallback(trackServiceRequest);
}

function extractHeaders(options: RequestOptions) {
    let extracted: { [key: string]: string } = {};

    let headers: Headers = options && <Headers>options.headers;
    if (headers) {
        headers.forEach((v, n) => (extracted[n.toLowerCase()] = v));
        if ('x-owa-urlpostdata' in extracted) {
            extracted['x-owa-urlpostdata'] = JSON.parse(
                decodeURIComponent(extracted['x-owa-urlpostdata'])
            );
        }
    }
    return extracted;
}

function generateDataPoint(
    response: Response,
    url: string,
    options: InternalRequestOptions,
    startTime: Date
) {
    let headers = extractHeaders(options);
    let timingDiagnostics: string[] = ['0', '0', '0'];
    let duration = new Date().getTime() - startTime.getTime();
    let requestId = '';

    if (response?.headers) {
        if (response.headers.has('x-owa-diagnosticsinfo')) {
            timingDiagnostics = response.headers.get('x-owa-diagnosticsinfo').split(';');
        }

        if (response.headers.has('request-id')) {
            requestId = response.headers.get('request-id');
        }
    }

    return {
        requestId: requestId,
        action: headers.action,
        beServer: headers.beserver,
        request: {
            url,
            body: options?.body ? JSON.parse(<string>options.body) : {},
            headers: headers,
            status: response ? `${response.status} ${response.statusText}` : 'Error',
        },
        timing: {
            start: startTime.toLocaleTimeString(),
            serverTime: parseInt(timingDiagnostics[0]),
            adTime: parseInt(timingDiagnostics[1]),
            rpcTime: parseInt(timingDiagnostics[2]),
            total: duration,
        },
    };
}

function trackServiceRequest(
    responsePromise: Promise<Response>,
    actionName: string,
    url: string,
    attemptCount: number,
    options: RequestOptions
) {
    const approximateStartTime = new Date();

    responsePromise
        .then(response => {
            logServiceRequestDiagnostics(
                generateDataPoint(response, url, options, approximateStartTime)
            );
        })
        .catch(err => {
            logServiceRequestDiagnostics(
                generateDataPoint(null, url, options, approximateStartTime)
            );
        });
}
